import Spends from './Spends'
export default Spends
